import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'child-cell',
    template: `<span class="hover-buttons"><button *ngIf='showDownload' style="margin-top:0px;padding: 1px 3px !important;"  color="link" size="sm" class="waves-light edit-button btn btn-sm" (click)="edit()" >
    <i [ngClass]="showDownload ? 'icon-download' : 'icon-edit'"></i>
</button>
<button *ngIf='showDelete' style="margin-top:0px;padding: 1px 3px !important;"  color="link" size="sm" class="waves-light edit-button btn btn-sm" (click)="delete()" >
    <i [ngClass]="showDelete ? 'icon-delete' : 'icon-settings'"></i>
</button>
<button *ngIf='showEdit' style="margin-top:0px;padding: 1px 3px !important;"  color="link" size="sm" class="waves-light edit-button btn btn-sm" (click)="edit()" >
    <i class='icon-edit'></i>
</button>
</span>`,
    styles: [
    ]
})
export class EditAndDeleteOperationsRenderer implements ICellRendererAngularComp { public params: any;
  showDownload: boolean = false;
  showDelete: boolean = false;
  showEdit: boolean = false;
    agInit(params: any): void {
      this.params = params;
      //debugger;
      params.data.FileName ? this.showDownload = true : this.showDownload = false;
      params.colDef.IsRequiredDelete ? this.showDelete = true : this.showDelete = false;
      params.colDef.IsRequiredEdit ? this.showEdit = true : this.showEdit = false;
    }

    public delete() {
        this.params.context.componentParent.deleteRow(this.params)
    }

    public edit() {
        this.params.context.componentParent.editRow(this.params)
    }

    refresh(): boolean {
        return false;
    }
}
